export const createSequencer = (config) => {
  const { func, interval, getArgId } = config
  const argUniqnessSet = new Set()
  const queue = []
  let scheduled = false

  const delayInvocationDecorator = (...args) => {
    const argId = getArgId(args)

    if (!argUniqnessSet.has(argId)) {
      argUniqnessSet.add(argId)
      queue.push(args)
    }

    if (scheduled) {
      return
    }

    scheduled = true

    const runner = () => {
      if (!queue.length) {
        scheduled = false
        argUniqnessSet.clear()
        return
      }

      const storedArgs = queue.shift()

      func(...storedArgs)

      setTimeout(runner, interval)
    }

    runner()
  }

  return delayInvocationDecorator
}
